// extracted by mini-css-extract-plugin
module.exports = {"container":"jx-z","products":"kx-z","cta":"lx-z","disabled":"mx-z"};